<template>
  <v-system-bar
    v-if="showAlert && $vuetify.breakpoint.smAndUp"
    app
    height="60px"
    class="d-flex align-center pl-16 pr-4 system_message text-body-1">
    
    <v-spacer />
    <div class="d-flex align-center text-body-1" style="max-width:66vw"><v-icon v-if="this.icon" class="global-thin system_message mr-6 material-symbols-outlined" style="font-size: 40px;">{{ icon }}</v-icon>
    <div class="system_message mr-6" style="padding-left:6px;line-height:18px;max-height:54px"><strong v-if="topic">{{ topic }}</strong>
      <p class="ma-0">{{ message }}</p>
    </div>
    <v-btn class="d-flex align-center system_message_button" v-if="buttonLink" :href="buttonLink" target="_blank">{{ buttonLabel }}</v-btn>
    </div>
    
    <v-spacer />
    
    <v-btn width="48" height="48" icon @click="closeSystemMessageBar" style="position:absolute;right:16px">
      <v-icon class="material-symbols-outlined mr-0">close</v-icon>
    </v-btn>
    </v-system-bar>
</template>

<script>
import SystemMessage from '@/lib/systemAlerts/SystemMessage';

export default {
  name: 'SystemMessageDisplay',
  props: {
    systemMessage: {
      type: SystemMessage,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    topic() {
      return this.systemMessage?.topic;
    },
    message() {
      return this.systemMessage?.message;
    },
    buttonLabel() {
      return this.systemMessage?.buttonLabel;
    },
    buttonLink() {
      return this.systemMessage?.buttonLink;
    },
    icon() {
      return this.systemMessage?.icon;
    },
    showAlert: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
  },
  methods: {
    closeSystemMessageBar() {
      this.showAlert = false;
    },
  },
};
</script>

<style scoped>

</style>
